var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table-not-approval-num cursor"},[_c('span',{on:{"click":function($event){return _vm.toExamineApprove(_vm.scope.row._id)}}},[_vm._v("\n    "+_vm._s(_vm.scope.row.notApprovalNum)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }